import type { VideoRenderingStatus } from '@src/types.ts/story';

/**
 * Window events relating to video rendering. Surfaces that hold their own
 * (detached) copy of a video — e.g. the clip-share modal's session store —
 * listen here to react by id, without depending on the change reaching a
 * specific object graph such as `videoClipPreview`.
 */

/**
 * Fired by `VideoCreatorStore.applyFinishedVideoStatus` (driven by the
 * PublishRecord subscription via `applyRenderedPublishRecords`) once a video's
 * render has finished — i.e. it reached a final state (rendered with a
 * file, or errored), not an intermediate "rendering" update.
 */
export const VIDEO_RENDER_FINISHED_EVENT = 'video-render-finished';

export type VideoRenderFinishedEventDetail = VideoRenderingStatus;
